function formatMoney(cents) {
  var amount = (cents / 100).toFixed(2);
  var parts = amount.split('.');
  parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  return '$' + parts[0] + '.' + parts[1];
}

if (!customElements.get('product-recommendations')) {
  customElements.define('product-recommendations', class extends HTMLElement {
    connectedCallback() {
      var url = this.dataset.url;
      if (!url) return;
      fetch(url)
        .then(function (res) { return res.text(); })
        .then(function (text) {
          var wrapper = document.createElement('div');
          wrapper.innerHTML = text;
          var content = wrapper.querySelector('product-recommendations');
          if (content && content.innerHTML.trim().length) {
            this.innerHTML = content.innerHTML;
            initScrollCarousels(this);
          } else {
            this.remove();
          }
        }.bind(this))
        .catch(function () { this.remove(); }.bind(this));
    }
  });
}

function initScrollCarousels(root) {
  (root || document).querySelectorAll('[data-scroll-carousel]').forEach(function (carousel) {
    if (carousel.dataset.carouselInit) return;
    carousel.dataset.carouselInit = 'true';

    var track = carousel.querySelector('[data-scroll-track]');
    var prevBtn = carousel.querySelector('[data-scroll-prev]');
    var nextBtn = carousel.querySelector('[data-scroll-next]');
    var thumb = carousel.querySelector('[data-scroll-progress-thumb]');
    if (!track) return;

    function updateProgress() {
      var maxScroll = track.scrollWidth - track.clientWidth;
      if (maxScroll <= 0) {
        if (thumb) { thumb.style.width = '100%'; thumb.style.left = '0%'; }
        if (prevBtn) prevBtn.disabled = true;
        if (nextBtn) nextBtn.disabled = true;
        return;
      }
      var visibleRatio = track.clientWidth / track.scrollWidth;
      var progress = track.scrollLeft / maxScroll;
      var thumbWidthPct = Math.max(visibleRatio * 100, 8);
      var thumbLeftPct = progress * (100 - thumbWidthPct);
      if (thumb) {
        thumb.style.width = thumbWidthPct + '%';
        thumb.style.left = thumbLeftPct + '%';
      }
      if (prevBtn) prevBtn.disabled = track.scrollLeft <= 2;
      if (nextBtn) nextBtn.disabled = track.scrollLeft >= maxScroll - 2;
    }

    function scrollByCard(direction) {
      var card = track.querySelector('.product-card');
      var amount = card ? card.getBoundingClientRect().width + 14 : track.clientWidth * 0.8;
      track.scrollBy({ left: amount * direction, behavior: 'smooth' });
    }

    track.addEventListener('scroll', updateProgress, { passive: true });
    window.addEventListener('resize', updateProgress);
    if (prevBtn) prevBtn.addEventListener('click', function () { scrollByCard(-1); });
    if (nextBtn) nextBtn.addEventListener('click', function () { scrollByCard(1); });

    updateProgress();
  });
}

document.addEventListener('DOMContentLoaded', function () {

  /* ---------- Predictive search ---------- */
  document.querySelectorAll('[data-predictive-search]').forEach(function (form) {
    var input = form.querySelector('[data-predictive-search-input]');
    var resultsBox = form.querySelector('[data-predictive-search-results]');
    if (!input || !resultsBox) return;

    var debounceTimer;
    var currentQuery = '';
    var activeIndex = -1;

    function closeResults() {
      resultsBox.hidden = true;
      resultsBox.innerHTML = '';
      activeIndex = -1;
    }

    function renderResults(products, query) {
      if (!products.length) {
        resultsBox.innerHTML = '<p class="search-predictive-results__empty">No products found for "' + query + '"</p>';
        resultsBox.hidden = false;
        return;
      }

      var html = products.map(function (product) {
        return (
          '<a href="' + product.url + '" class="search-predictive-results__item">' +
            '<span class="search-predictive-results__image">' +
              (product.image ? '<img src="' + product.image + '" alt="" loading="lazy">' : '') +
            '</span>' +
            '<span class="search-predictive-results__info">' +
              '<span class="search-predictive-results__title">' + product.title + '</span>' +
              (product.vendor ? '<span class="search-predictive-results__vendor">' + product.vendor + '</span>' : '') +
            '</span>' +
            '<span class="search-predictive-results__price">' + formatMoney(Math.round(parseFloat(product.price) * 100)) + '</span>' +
          '</a>'
        );
      }).join('');

      html += '<a href="' + form.action + '?q=' + encodeURIComponent(query) + '&type=product" class="search-predictive-results__viewall">View all results</a>';

      resultsBox.innerHTML = html;
      resultsBox.hidden = false;
      activeIndex = -1;
    }

    function fetchResults(query) {
      fetch('/search/suggest.json?q=' + encodeURIComponent(query) + '&resources[type]=product&resources[limit]=6&resources[options][unavailable_products]=last')
        .then(function (res) { return res.json(); })
        .then(function (data) {
          if (query !== currentQuery) return; // stale response, a newer query has since been typed
          var products = (data.resources && data.resources.results && data.resources.results.products) || [];
          renderResults(products, query);
        })
        .catch(function () { closeResults(); });
    }

    input.addEventListener('input', function () {
      var query = input.value.trim();
      currentQuery = query;
      clearTimeout(debounceTimer);

      if (query.length < 2) {
        closeResults();
        return;
      }

      resultsBox.innerHTML = '<p class="search-predictive-results__loading">Searching…</p>';
      resultsBox.hidden = false;

      debounceTimer = setTimeout(function () { fetchResults(query); }, 250);
    });

    input.addEventListener('keydown', function (e) {
      var items = resultsBox.querySelectorAll('.search-predictive-results__item');
      if (!items.length) return;

      if (e.key === 'ArrowDown') {
        e.preventDefault();
        activeIndex = Math.min(activeIndex + 1, items.length - 1);
        items.forEach(function (item, i) { item.classList.toggle('is-active', i === activeIndex); });
        items[activeIndex].scrollIntoView({ block: 'nearest' });
      } else if (e.key === 'ArrowUp') {
        e.preventDefault();
        activeIndex = Math.max(activeIndex - 1, 0);
        items.forEach(function (item, i) { item.classList.toggle('is-active', i === activeIndex); });
        items[activeIndex].scrollIntoView({ block: 'nearest' });
      } else if (e.key === 'Enter' && activeIndex >= 0) {
        e.preventDefault();
        window.location.href = items[activeIndex].href;
      } else if (e.key === 'Escape') {
        closeResults();
      }
    });

    document.addEventListener('click', function (e) {
      if (!form.contains(e.target)) closeResults();
    });
  });

  /* ---------- Mobile nav ---------- */
  var menuToggle = document.querySelector('[data-menu-toggle]');
  var mobileNav = document.querySelector('[data-mobile-nav]');
  if (menuToggle && mobileNav) {
    menuToggle.addEventListener('click', function () {
      var isOpen = mobileNav.hasAttribute('data-open');
      if (isOpen) {
        mobileNav.removeAttribute('data-open');
        mobileNav.hidden = true;
        menuToggle.setAttribute('aria-expanded', 'false');
      } else {
        mobileNav.hidden = false;
        mobileNav.setAttribute('data-open', '');
        menuToggle.setAttribute('aria-expanded', 'true');
      }
    });
  }
  document.querySelectorAll('[data-mobile-submenu-toggle]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var submenu = btn.nextElementSibling;
      if (!submenu) return;
      var isOpen = submenu.hasAttribute('data-open');
      if (isOpen) { submenu.removeAttribute('data-open'); }
      else { submenu.setAttribute('data-open', ''); }
    });
  });

  /* ---------- Mobile search toggle ---------- */
  var searchToggle = document.querySelector('[data-search-toggle]');
  var searchForm = document.querySelector('[data-search-form]');
  if (searchToggle && searchForm) {
    searchToggle.addEventListener('click', function () {
      var isOpen = searchForm.classList.contains('is-open');
      if (isOpen) {
        searchForm.classList.remove('is-open');
        searchToggle.setAttribute('aria-expanded', 'false');
      } else {
        searchForm.classList.add('is-open');
        searchToggle.setAttribute('aria-expanded', 'true');
        var input = searchForm.querySelector('[data-predictive-search-input]');
        if (input) input.focus();
      }
    });
  }

  /* ---------- Scroll carousels (featured collection, etc.) ---------- */
  initScrollCarousels(document);

  /* ---------- Recently viewed ---------- */
  (function () {
    var STORAGE_KEY = 'fv_recently_viewed';
    var MAX_ITEMS = 12;

    function getViewedHandles() {
      try {
        var raw = window.localStorage.getItem(STORAGE_KEY);
        return raw ? JSON.parse(raw) : [];
      } catch (e) {
        return [];
      }
    }

    function saveViewedHandles(handles) {
      try {
        window.localStorage.setItem(STORAGE_KEY, JSON.stringify(handles));
      } catch (e) { /* localStorage unavailable - silently skip */ }
    }

    // Track the current product page, if any
    var currentProductEl = document.querySelector('.product');
    var currentHandleFromSection = document.querySelector('[data-recently-viewed]');
    var currentHandle = currentHandleFromSection ? currentHandleFromSection.getAttribute('data-current-handle') : '';

    if (currentProductEl && currentHandle) {
      var handles = getViewedHandles().filter(function (h) { return h !== currentHandle; });
      handles.unshift(currentHandle);
      if (handles.length > MAX_ITEMS) handles = handles.slice(0, MAX_ITEMS);
      saveViewedHandles(handles);
    }

    // Render the recently-viewed section, excluding the current product
    var section = document.querySelector('[data-recently-viewed]');
    if (!section) return;
    var track = section.querySelector('[data-recently-viewed-track]');
    if (!track) return;

    var toShow = getViewedHandles().filter(function (h) { return h !== currentHandle; }).slice(0, 12);
    if (!toShow.length) return;

    Promise.all(
      toShow.map(function (handle) {
        return fetch('/products/' + handle + '.js')
          .then(function (res) { return res.ok ? res.json() : null; })
          .catch(function () { return null; });
      })
    ).then(function (products) {
      var valid = products.filter(Boolean);
      if (!valid.length) return;

      var html = valid.map(function (product) {
        var image = product.featured_image || (product.images && product.images[0]) || '';
        var onSale = product.compare_at_price_max && product.compare_at_price_max > product.price;
        return (
          '<div class="product-card">' +
            '<a href="/products/' + product.handle + '" class="product-card__media-link">' +
              '<div class="product-card__media">' +
                (image ? '<img class="product-card__image product-card__image--main" src="' + image + '" alt="' + (product.title || '').replace(/"/g, '&quot;') + '" loading="lazy">' : '') +
                (onSale ? '<span class="product-card__badge">Sale</span>' : '') +
              '</div>' +
            '</a>' +
            '<div class="product-card__info">' +
              (product.vendor ? '<a href="/collections/' + product.vendor.toLowerCase().replace(/\s+/g, '-') + '" class="product-card__vendor">' + product.vendor + '</a>' : '') +
              '<h3 class="product-card__title"><a href="/products/' + product.handle + '">' + product.title + '</a></h3>' +
              '<span class="price' + (onSale ? ' price--on-sale' : '') + '">' +
                (onSale ? '<span class="price__compare-at">' + formatMoney(product.compare_at_price_max) + '</span>' : '') +
                '<span class="price__current">' + formatMoney(product.price) + '</span>' +
              '</span>' +
              '<a href="/products/' + product.handle + '" class="button button--secondary product-card__cta">View details</a>' +
            '</div>' +
          '</div>'
        );
      }).join('');

      track.innerHTML = html;
      section.hidden = false;
      initScrollCarousels(section);
    });
  })();

  /* ---------- Product page: variant switching ---------- */
  document.querySelectorAll('.product').forEach(function (productEl) {
    var variantScript = productEl.querySelector('[data-product-variants]');
    if (!variantScript) return;
    var variants;
    try { variants = JSON.parse(variantScript.textContent); } catch (e) { return; }

    var optionSelectors = productEl.querySelectorAll('[data-option-selector]');
    var swatchButtons = productEl.querySelectorAll('.swatch');
    var variantIdInput = productEl.querySelector('[data-product-variant-id]');
    var priceWrap = productEl.querySelector('[data-product-price]');
    var availabilityWrap = productEl.querySelector('[data-product-availability]');
    var skuWrap = productEl.querySelector('[data-product-sku]');
    var addToCartBtn = productEl.querySelector('[data-add-to-cart]');
    var addToCartText = productEl.querySelector('[data-add-to-cart-text]');

    function getSelectedOptions() {
      var selected = [];
      var optionGroups = productEl.querySelectorAll('[data-option-index]');
      var byIndex = {};
      optionGroups.forEach(function (group) {
        var index = group.getAttribute('data-option-index');
        var select = group.querySelector('[data-option-selector]');
        if (select) { byIndex[index] = select.value; }
      });
      swatchButtons.forEach(function (btn) {
        if (btn.classList.contains('is-selected')) {
          byIndex[btn.getAttribute('data-option-index')] = btn.getAttribute('data-option-value');
        }
      });
      var i = 0;
      while (byIndex[i] !== undefined) { selected.push(byIndex[i]); i++; }
      return selected;
    }

    function findMatchingVariant() {
      var selected = getSelectedOptions();
      return variants.find(function (v) {
        var opts = [v.option1, v.option2, v.option3].filter(function (o) { return o !== null && o !== undefined; });
        return opts.length === selected.length && opts.every(function (o, i) { return o === selected[i]; });
      });
    }

    function updateUI() {
      var variant = findMatchingVariant();
      if (!variant) return;

      if (variantIdInput) variantIdInput.value = variant.id;

      if (priceWrap) {
        var priceEl = priceWrap.querySelector('.price');
        var compareEl = priceWrap.querySelector('.price__compare-at');
        var currentEl = priceWrap.querySelector('.price__current');
        if (currentEl) currentEl.textContent = formatMoney(variant.price);
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          priceEl.classList.add('price--on-sale');
          if (compareEl) { compareEl.textContent = formatMoney(variant.compare_at_price); compareEl.style.display = ''; }
        } else {
          priceEl.classList.remove('price--on-sale');
          if (compareEl) compareEl.style.display = 'none';
        }
      }

      if (availabilityWrap) {
        availabilityWrap.innerHTML = variant.available
          ? '<span class="dot dot--in-stock"></span> In stock, ready to ship'
          : '<span class="dot dot--out"></span> Out of stock';
      }

      if (skuWrap) {
        if (variant.sku) {
          skuWrap.hidden = false;
          var skuValueEl = skuWrap.querySelector('.mono');
          if (skuValueEl) skuValueEl.textContent = variant.sku;
        } else {
          skuWrap.hidden = true;
        }
      }

      if (addToCartBtn) {
        addToCartBtn.disabled = !variant.available;
        if (addToCartText) addToCartText.textContent = variant.available ? 'Add to cart' : 'Sold out';
      }

      var media = productEl.querySelector('[data-media-id="' + variant.featured_media_id + '"]');
      if (media) {
        productEl.querySelectorAll('.product__media-item').forEach(function (m) { m.classList.remove('is-active'); });
        media.classList.add('is-active');
        productEl.querySelectorAll('.product__media-thumb').forEach(function (t) {
          t.classList.toggle('is-active', t.getAttribute('data-media-id') === String(variant.featured_media_id));
        });
      }
    }

    optionSelectors.forEach(function (select) {
      select.addEventListener('change', updateUI);
    });

    swatchButtons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var group = btn.closest('.swatch-list');
        group.querySelectorAll('.swatch').forEach(function (b) { b.classList.remove('is-selected'); });
        btn.classList.add('is-selected');
        var label = btn.closest('.product-form__option').querySelector('[data-selected-value]');
        if (label) label.textContent = btn.getAttribute('data-option-value');
        updateUI();
      });
    });

    /* Media thumbnail clicks */
    productEl.querySelectorAll('[data-media-thumb]').forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var mediaId = thumb.getAttribute('data-media-id');
        productEl.querySelectorAll('.product__media-item').forEach(function (m) {
          m.classList.toggle('is-active', m.getAttribute('data-media-id') === mediaId);
        });
        productEl.querySelectorAll('.product__media-thumb').forEach(function (t) {
          t.classList.toggle('is-active', t === thumb);
        });
      });
    });

    /* Quantity stepper */
    var qtyInput = productEl.querySelector('[data-quantity-input]');
    var qtyDecrease = productEl.querySelector('[data-quantity-decrease]');
    var qtyIncrease = productEl.querySelector('[data-quantity-increase]');
    if (qtyInput && qtyDecrease && qtyIncrease) {
      qtyDecrease.addEventListener('click', function () {
        qtyInput.value = Math.max(1, parseInt(qtyInput.value || '1', 10) - 1);
      });
      qtyIncrease.addEventListener('click', function () {
        qtyInput.value = parseInt(qtyInput.value || '1', 10) + 1;
      });
    }

    /* AJAX add to cart with notification */
    var form = productEl.querySelector('#ProductForm');
    if (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var formData = new FormData(form);
        fetch('/cart/add.js', { method: 'POST', body: formData, headers: { Accept: 'application/json' } })
          .then(function (res) { return res.json(); })
          .then(function (data) {
            if (data.status) {
              showCartError(data.description || 'Unable to add this item to your cart.');
              return;
            }
            updateCartCount();
            showCartNotification(data);
          })
          .catch(function () { window.location.href = '/cart'; });
      });
    }
  });

  function updateCartCount() {
    fetch('/cart.js')
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        document.querySelectorAll('[data-cart-count]').forEach(function (el) {
          el.textContent = cart.item_count;
        });
      });
  }

  function showCartNotification(item) {
    var notification = document.getElementById('cart-notification');
    if (!notification) { window.location.href = '/cart'; return; }
    var body = notification.querySelector('.cart-notification__body');
    if (body) body.textContent = item.quantity + ' x ' + item.product_title + ' added to your cart.';
    notification.hidden = false;
    clearTimeout(window.__cartNotifTimeout);
    window.__cartNotifTimeout = setTimeout(function () { notification.hidden = true; }, 5000);
  }

  function showCartError(message) {
    var notification = document.getElementById('cart-notification');
    if (!notification) { alert(message); return; }
    var body = notification.querySelector('.cart-notification__body');
    if (body) body.textContent = message;
    notification.hidden = false;
    clearTimeout(window.__cartNotifTimeout);
    window.__cartNotifTimeout = setTimeout(function () { notification.hidden = true; }, 5000);
  }

  /* ---------- Cart page: live quantity updates (no Update Cart button needed) ---------- */
  var cartQuantityTimers = {};

  function applyCartChange(line, quantity) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ line: line, quantity: quantity })
    })
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        document.querySelectorAll('[data-cart-count]').forEach(function (el) {
          el.textContent = cart.item_count;
        });

        var subtotalEl = document.querySelector('[data-cart-subtotal]');
        if (subtotalEl) subtotalEl.textContent = formatMoney(cart.total_price);

        if (cart.item_count === 0) {
          window.location.reload();
          return;
        }

        if (quantity === 0) {
          var row = document.querySelector('[data-cart-row="' + line + '"]');
          if (row) row.remove();
          return;
        }

        var lineItem = cart.items[line - 1];
        var totalEl = document.querySelector('[data-line-total="' + line + '"]');
        if (lineItem && totalEl) totalEl.textContent = formatMoney(lineItem.final_line_price);
      })
      .catch(function () { window.location.reload(); });
  }

  document.querySelectorAll('[data-cart-decrease], [data-cart-increase]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var line = btn.getAttribute('data-line');
      var input = document.querySelector('[data-cart-quantity][data-line="' + line + '"]');
      if (!input) return;
      var value = parseInt(input.value || '0', 10);
      if (btn.hasAttribute('data-cart-decrease')) value = Math.max(0, value - 1);
      else value = value + 1;
      input.value = value;
      applyCartChange(line, value);
    });
  });

  document.querySelectorAll('[data-cart-quantity]').forEach(function (input) {
    input.addEventListener('input', function () {
      var line = input.getAttribute('data-line');
      clearTimeout(cartQuantityTimers[line]);
      cartQuantityTimers[line] = setTimeout(function () {
        var value = Math.max(0, parseInt(input.value || '0', 10));
        input.value = value;
        applyCartChange(line, value);
      }, 500);
    });
  });

  document.querySelectorAll('[data-cart-remove]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var line = btn.getAttribute('data-line');
      applyCartChange(line, 0);
    });
  });
});
